import React from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'

const ThemeProviderAdapter = ({ children, theme }) => (
  <ThemeProvider theme={theme}>
    <i className="fas fa-500px" style={{ color: 'transparent' }} />
    <CssBaseline />
    { children }
  </ThemeProvider>
)

ThemeProviderAdapter.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
}

export default ThemeProviderAdapter
